export const statisticTypes = {
    FETCH_REQUEST: 'STATISTICS_FETCH_REQUEST',
    FETCH_SUCCESS: 'STATISTICS_FETCH_SUCCESS',
    FETCH_FAILURE: 'STATISTICS_FETCH_FAILURE',
}